// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-list{text-align:center;padding:10px}.empty-list .icon{color:var(--color-txt);opacity:.4}.empty-list .icon,.empty-list .icon svg{width:20px;height:20px}", "",{"version":3,"sources":["webpack://./src/public/emptyList.vue"],"names":[],"mappings":"AACA,YACI,iBAAA,CACA,YAAA,CACA,kBACI,sBAAA,CACA,UAAA,CACA,wCAEI,UAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
